import { CfDataGridCell } from './CfDataGridCell';
import { CfDataGridCellBaseProps, getCellPropsFromCellPropsById } from './common';

export interface CfDataGridCellByIdProps<TItem, TAppState> extends CfDataGridCellBaseProps<TItem> {
  itemId: string | undefined;
  itemSelector: (itemId: string, store: TAppState) => TItem | undefined;
  useSelector: (itemSelector: (state: TAppState) => TItem | undefined) => TItem | undefined;
}

export function CfDataGridCellById<TItem, TAppState>(
  props: CfDataGridCellByIdProps<TItem, TAppState>
): JSX.Element | null {
  const itemId = props.itemId;
  let item: TItem | undefined = undefined;
  if (itemId !== undefined) item = props.useSelector((state) => props.itemSelector(itemId, state));
  return <CfDataGridCell {...getCellPropsFromCellPropsById(props, item)} />;
}
